var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.575 3.333H4.36a2.68 2.68 0 0 0-1.85.732 2.445 2.445 0 0 0-.767 1.768v8.334c0 .663.276 1.299.767 1.767a2.68 2.68 0 0 0 1.85.733h12.214a2.68 2.68 0 0 0 1.85-.733c.491-.468.767-1.104.767-1.767V5.833c0-.663-.276-1.299-.767-1.768a2.68 2.68 0 0 0-1.85-.732zM4.36 5h12.214c.231 0 .453.088.617.244a.815.815 0 0 1 .255.59L10.468 9.9l-6.98-4.067c0-.22.093-.433.256-.589A.894.894 0 0 1 4.361 5zm13.086 9.167a.814.814 0 0 1-.255.589.893.893 0 0 1-.617.244H4.36a.894.894 0 0 1-.617-.244.815.815 0 0 1-.255-.59V7.734l6.526 3.809a.904.904 0 0 0 .872 0l6.56-3.809v6.434z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.dc8a87982f9064c497a3a4051b489f62.svg";
export { ForwardRef as ReactComponent };